module.exports = __webpack_public_path__ + "img/location-pin.5e8ae3ca.svg";